import { useQuery } from "@tanstack/react-query";

import { n8nInstance } from "@shared/services/api";
import { BACKOFFICE_QUERIES } from "./queries";

import { convertObjectToCamelCase, handleApiError } from "@shared/helpers";
import { ICompanyDetails } from "@backoffice/types";

const api = n8nInstance({
  enableBearerToken: true,
  enableXTokenApi: true,
});

export const useGetCompanyDetails = ({ companyId }: { companyId?: string }) => {
  const getCompanyDetails = async (): Promise<{
    success: boolean;
    message: string;
    data?: ICompanyDetails;
  }> => {
    try {
      const { data } = await api.get(
        `6a34c9d1-0d37-4557-ae00-8d6525d1afa1/prd/v1/companies/${companyId}`,
      );

      return {
        success: true,
        message: "Detalhes da company encontrado com sucesso!",
        data: convertObjectToCamelCase(data) as ICompanyDetails,
      };
    } catch (error: any) {
      return handleApiError(error, "Erro ao buscar os detalhes da company!");
    }
  };

  return useQuery({
    queryKey: [BACKOFFICE_QUERIES.COMPANIES, companyId],
    queryFn: () => getCompanyDetails(),
    enabled: !!companyId,
  });
};
